import classNames from 'classnames';
import { UserIconType } from 'src/utils/constants/User';
import styles from './UserIcon.module.scss';

const UserIcon = ({
  userIcon = UserIconType.SINGLE,
  className = '',
}: {
  userIcon?: UserIconType;
  className?: string;
}) => {
  return <div className={classNames(className, styles['user-icon'], styles[`user-icon__${userIcon}`])} />;
};

export default UserIcon;
